"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.right = exports.left = exports.Right = exports.Left = void 0;
exports.splitArray = splitArray;
/**
 * Typically error / exception case
 */
class Left {
  constructor(value) {
    this.value = value;
  }
  isLeft() {
    return true;
  }
  isRight() {
    return false;
  }
}
exports.Left = Left;
/**
 * Typically success case
 */
class Right {
  constructor(value) {
    this.value = value;
  }
  isLeft() {
    return false;
  }
  isRight() {
    return true;
  }
}
exports.Right = Right;
const left = l => {
  return new Left(l);
};
exports.left = left;
const right = r => {
  return new Right(r);
};
exports.right = right;
function splitArray(arrayOfEither) {
  const sa = {
    lefts: [],
    rights: []
  };
  return arrayOfEither.reduce((acc, curr) => {
    if (curr.isLeft()) {
      acc.lefts.push(curr.value);
    } else {
      acc.rights.push(curr.value);
    }
    return acc;
  }, sa);
}